/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const PageBuildingIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="PageBuildingIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M6 10H8V11H6C5.44772 11 5 10.5523 5 10V3C5 2.44771 5.44772 2 6 2H13C13.5523 2 14 2.44771 14 3V7H13V3H6L6 10Z"
                fill="currentColor"
              />
              <path d="M10 7V14L12 12H15L10 7Z" fill="currentColor" />
            </g>
            <g opacity="0.4">
              <path
                d="M3 14C2.44772 14 2 13.5523 2 13V11.5H3V13H4.5V14H3Z"
                fill="currentColor"
              />
              <path d="M6 13H8V14H6V13Z" fill="currentColor" />
              <path d="M3 8V10H2V8H3Z" fill="currentColor" />
              <path
                d="M2 6.5V5C2 4.44772 2.44772 4 3 4H4V5H3V6.5H2Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

PageBuildingIcon.tags = [
  'cursor',
  'design',
  'drag',
  'drop',
  'layout',
  'move',
  'interface',
  'edit',
  'arrange',
];

PageBuildingIcon.category = 'General Icons';

PageBuildingIcon.iconSize = 16;
